module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Blog Mansory Page"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Blog Mansory Page")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row-mansory"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well-media"
  }, [_c('div', {
    staticClass: "vendor"
  }, [_c('div', {
    staticClass: "fluid-width-video-wrapper embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": "http://www.youtube.com/embed/BO03CROMVjo",
      "frameborder": "0",
      "allowfullscreen": "",
      "id": "fitvid741674"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "video-text"
  }, [_c('h2', [_vm._v("Baby Shark Dance | Sing and Dance! | Animal Songs | PINKFONG Songs for Children\n")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus et dui id justo rhoncus consequat. Aliquam porttitor, arcu quis ornare ultricies, augue neque fringilla turpis.")])]), _vm._v(" "), _c('div', {
    staticClass: "tag-nest"
  }, [_c('i', [_vm._v("angel")]), _c('i', [_vm._v("dark")]), _c('i', [_vm._v("mistic")])]), _vm._v(" "), _c('div', {
    staticClass: "video-category-bg"
  }, [_c('h3', [_vm._v("Video")]), _vm._v(" "), _c('a', {
    staticClass: "link-media pull-right",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fontawesome-film"
  })]), _vm._v(" "), _c('div', {
    staticClass: "triangle-white"
  }), _vm._v(" "), _c('div', {
    staticClass: "triangle-video-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well-media"
  }, [_c('div', {
    staticClass: "vendor"
  }, [_c('a', {
    staticClass: "fancybox",
    attrs: {
      "rel": "group",
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-responsive-media",
    attrs: {
      "src": "https://source.unsplash.com/collection/190727/1500x900",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "video-text"
  }, [_c('h2', [_vm._v("Black Angel")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit.")])]), _vm._v(" "), _c('div', {
    staticClass: "tag-nest"
  }, [_c('i', [_vm._v("angel")]), _c('i', [_vm._v("dark")]), _c('i', [_vm._v("mistic")])]), _vm._v(" "), _c('div', {
    staticClass: "photo-category-bg"
  }, [_c('h3', [_vm._v("Photo")]), _vm._v(" "), _c('a', {
    staticClass: "link-media pull-right",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fontawesome-picture"
  })]), _vm._v(" "), _c('div', {
    staticClass: "triangle-white"
  }), _vm._v(" "), _c('div', {
    staticClass: "triangle-photo-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well-media"
  }, [_c('div', {
    staticClass: "vendor embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": "http://www.youtube.com/embed/dqb4o3ycv4k",
      "frameborder": "0",
      "allowfullscreen": "",
      "id": "fitvid741674"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "video-text"
  }, [_c('h2', [_vm._v("Coldplay ft The Chainsmokers - Look What You Made Me Do")]), _vm._v(" "), _c('p', [_vm._v("I do not own the music and the background.\n\nCopyright Disclaimer Under Section 107 of the Copyright Act 1976")])]), _vm._v(" "), _c('div', {
    staticClass: "tag-nest"
  }, [_c('i', [_vm._v("patah ")]), _c('i', [_vm._v("hati")]), _c('i', [_vm._v("music")])]), _vm._v(" "), _c('div', {
    staticClass: "audio-category-bg"
  }, [_c('h3', [_vm._v("audio")]), _vm._v(" "), _c('a', {
    staticClass: "link-media pull-right",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "entypo-note-beamed"
  })]), _vm._v(" "), _c('div', {
    staticClass: "triangle-white"
  }), _vm._v(" "), _c('div', {
    staticClass: "triangle-audio-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well-media"
  }, [_c('div', {
    staticClass: "vendor"
  }, [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "data-ride": "carousel",
      "id": "carousel-example-generic"
    }
  }, [_c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    attrs: {
      "data-slide-to": "0",
      "data-target": "#carousel-example-generic"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "active",
    attrs: {
      "data-slide-to": "1",
      "data-target": "#carousel-example-generic"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-slide-to": "2",
      "data-target": "#carousel-example-generic"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "img-responsive-media",
    attrs: {
      "alt": "First slide",
      "src": "https://source.unsplash.com/collection/431862/800x600"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item active"
  }, [_c('img', {
    staticClass: "img-responsive-media",
    attrs: {
      "alt": "Second slide",
      "src": "https://source.unsplash.com/collection/474045/800x600"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "img-responsive-media",
    attrs: {
      "alt": "Third slide",
      "src": "https://source.unsplash.com/collection/981639/800x600"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "data-slide": "prev",
      "href": "#carousel-example-generic"
    }
  }, [_c('span', {
    staticClass: "devin-panel-car ti-arrow-circle-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "data-slide": "next",
      "href": "#carousel-example-generic"
    }
  }, [_c('span', {
    staticClass: "devin-panel-car ti-arrow-circle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "video-text"
  }, [_c('h2', [_vm._v("Holyday")]), _vm._v(" "), _c('p', [_vm._v("It ws may last summer holyday")])]), _vm._v(" "), _c('div', {
    staticClass: "tag-nest"
  }, [_c('i', [_vm._v("angel")]), _c('i', [_vm._v("dark")]), _c('i', [_vm._v("mistic")])]), _vm._v(" "), _c('div', {
    staticClass: "album-category-bg"
  }, [_c('h3', [_vm._v("Photoset")]), _vm._v(" "), _c('a', {
    staticClass: "link-media pull-right",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "entypo-picture"
  })]), _vm._v(" "), _c('div', {
    staticClass: "triangle-white"
  }), _vm._v(" "), _c('div', {
    staticClass: "triangle-album-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well-media"
  }, [_c('div', {
    staticClass: "vendor"
  }, [_c('div', {
    staticClass: "fluid-width-video-wrapper embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": "//www.youtube.com/embed/ICAisYcDNqw",
      "frameborder": "0",
      "allowfullscreen": "",
      "id": "fitvid892886"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "video-text"
  }, [_c('h2', [_vm._v("Black Angel")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus et dui id justo rhoncus consequat. Aliquam porttitor, arcu quis ornare ultricies, augue neque fringilla turpis.")])]), _vm._v(" "), _c('div', {
    staticClass: "tag-nest"
  }, [_c('i', [_vm._v("angel")]), _c('i', [_vm._v("dark")]), _c('i', [_vm._v("mistic")])]), _vm._v(" "), _c('div', {
    staticClass: "video-category-bg"
  }, [_c('h3', [_vm._v("Video")]), _vm._v(" "), _c('a', {
    staticClass: "link-media pull-right",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fontawesome-film"
  })]), _vm._v(" "), _c('div', {
    staticClass: "triangle-white"
  }), _vm._v(" "), _c('div', {
    staticClass: "triangle-video-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well-media"
  }, [_c('div', {
    staticClass: "vendor"
  }, [_c('a', {
    attrs: {
      "rel": "group",
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-responsive-media",
    attrs: {
      "src": "http://lorempixel.com/output/food-h-c-350-450-8.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "video-text"
  }, [_c('h2', [_vm._v("Black Angel")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit.")])]), _vm._v(" "), _c('div', {
    staticClass: "tag-nest"
  }, [_c('i', [_vm._v("angel")]), _c('i', [_vm._v("dark")]), _c('i', [_vm._v("mistic")])]), _vm._v(" "), _c('div', {
    staticClass: "photo-category-bg"
  }, [_c('h3', [_vm._v("Photo")]), _vm._v(" "), _c('a', {
    staticClass: "link-media pull-right",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fontawesome-picture"
  })]), _vm._v(" "), _c('div', {
    staticClass: "triangle-white"
  }), _vm._v(" "), _c('div', {
    staticClass: "triangle-photo-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well-media"
  }, [_c('div', {
    staticClass: "vendor"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "166",
      "scrolling": "no",
      "frameborder": "no",
      "src": "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/88278446&color=ff5500&auto_play=false&hide_related=false&show_artwork=true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "video-text"
  }, [_c('h2', [_vm._v("Favright")]), _vm._v(" "), _c('p', [_vm._v("Favright - Taking Over (feat. Cassandra Kay)")])]), _vm._v(" "), _c('div', {
    staticClass: "tag-nest"
  }, [_c('i', [_vm._v("patah ")]), _c('i', [_vm._v("hati")]), _c('i', [_vm._v("music")])]), _vm._v(" "), _c('div', {
    staticClass: "audio-category-bg"
  }, [_c('h3', [_vm._v("audio")]), _vm._v(" "), _c('a', {
    staticClass: "link-media pull-right",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "entypo-note-beamed"
  })]), _vm._v(" "), _c('div', {
    staticClass: "triangle-white"
  }), _vm._v(" "), _c('div', {
    staticClass: "triangle-audio-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well-media"
  }, [_c('div', {
    staticClass: "vendor"
  }, [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "data-ride": "carousel",
      "id": "carousel-dua"
    }
  }, [_c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    attrs: {
      "data-slide-to": "0",
      "data-target": "#carousel-dua"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-slide-to": "1",
      "data-target": "#carousel-dua"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "active",
    attrs: {
      "data-slide-to": "2",
      "data-target": "#carousel-dua"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "img-responsive-media",
    attrs: {
      "alt": "First slide",
      "data-src": "holder.js/900x500/auto/#777:#555/text:First slide",
      "src": "http://placehold.it/350x250"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "img-responsive-media",
    attrs: {
      "alt": "Second slide",
      "data-src": "holder.js/900x500/auto/#666:#444/text:Second slide",
      "src": "http://placehold.it/350x250"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item active"
  }, [_c('img', {
    staticClass: "img-responsive-media",
    attrs: {
      "alt": "Third slide",
      "data-src": "holder.js/900x500/auto/#555:#333/text:Third slide",
      "src": "http://placehold.it/350x250"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "data-slide": "prev",
      "href": "#carousel-dua"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "data-slide": "next",
      "href": "#carousel-dua"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "video-text"
  }, [_c('h2', [_vm._v("Holyday")]), _vm._v(" "), _c('p', [_vm._v("It ws may last summer holyday")])]), _vm._v(" "), _c('div', {
    staticClass: "tag-nest"
  }, [_c('i', [_vm._v("angel")]), _c('i', [_vm._v("dark")]), _c('i', [_vm._v("mistic")])]), _vm._v(" "), _c('div', {
    staticClass: "album-category-bg"
  }, [_c('h3', [_vm._v("Photoset")]), _vm._v(" "), _c('a', {
    staticClass: "link-media pull-right",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "entypo-picture"
  })]), _vm._v(" "), _c('div', {
    staticClass: "triangle-white"
  }), _vm._v(" "), _c('div', {
    staticClass: "triangle-album-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well-media"
  }, [_c('div', {
    staticClass: "vendor"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "166",
      "scrolling": "no",
      "frameborder": "no",
      "src": "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/149950304&color=ff5500&auto_play=false&hide_related=false&show_artwork=true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "video-text"
  }, [_c('h2', [_vm._v("Terlatih Patah Hati")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit.")])]), _vm._v(" "), _c('div', {
    staticClass: "tag-nest"
  }, [_c('i', [_vm._v("patah ")]), _c('i', [_vm._v("hati")]), _c('i', [_vm._v("music")])]), _vm._v(" "), _c('div', {
    staticClass: "audio-category-bg"
  }, [_c('h3', [_vm._v("audio")]), _vm._v(" "), _c('a', {
    staticClass: "link-media pull-right",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "entypo-note-beamed"
  })]), _vm._v(" "), _c('div', {
    staticClass: "triangle-white"
  }), _vm._v(" "), _c('div', {
    staticClass: "triangle-audio-right"
  })])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f10f5ff2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/BlogMansory.vue
// module id = 1446
// module chunks = 2